import { useQuery } from "@tanstack/react-query";
import config from "./config";
import { ResponseError } from "./types/responseError";
import Cookies from "js-cookie";
import {
  GetRegistrationCountriesResponse,
  GetRegistrationCountriesQuery,
} from "./dtos/get-registration-countries.dto";

export const useGetRegistrationCountries = (
  queryParams?: GetRegistrationCountriesQuery,
) =>
  useQuery<GetRegistrationCountriesResponse, ResponseError>({
    queryKey: ["registration-countries", queryParams?.language],
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      if (queryParams?.language) {
        searchParams.append("language", queryParams.language);
      }

      const url = `${config.SID_GW_BASE_URL}/v1/investor/registration/countries${
        searchParams.toString() ? `?${searchParams.toString()}` : ""
      }`;

      const response = await fetch(url, {
        credentials: "include",
        headers: {
          Authorization: Cookies.get("auth-token") ?? "",
        },
      });

      if (!response.ok) {
        console.error(await response.text());
        throw new ResponseError(
          "Error fetching registration countries",
          response,
        );
      }

      return response.json();
    },
  });
